import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useUser } from "../../context/UserContext";
import { useRefreshSettings } from "../../hooks/useRefreshSettings";

export const SettingsProvider = ({ children }) => {
  const refreshSettings = useRefreshSettings();
  const { userId } = useUser();
  const settings = useSelector((state: RootState) => state.settings.settings);

  useEffect(() => {
    if (userId && userId > 0 && settings.length === 0) {
      refreshSettings();
    }
  }, [refreshSettings, settings.length, userId]);

  return children;
};
